import * as ABCya from '@abcya/abcya_phaser';
import gameData from '../../gameData';
import { pause } from './pauseScreen';

export function menuUI(scene,numDots = 12,spacing = 14)
{
    gameData.uiBar = ABCya.Images.addImage(512,28,"General UI/Nav_Bar",scene).setDepth(6).setAlpha(0);
    gameData.uiMenu = ABCya.Images.addImage(92,86,"General UI/Btn_Menu",scene).setDepth(6).setAlpha(0);
    gameData.uiMute = ABCya.Images.addImage(932,86,"General UI/Btn_Unmute",scene).setDepth(6).setAlpha(0);
    if(scene.custSound.tracks.bgMusic.customMute === true)gameData.uiMute.setFrame("General UI/Btn_Mute");

    const posY = 23;
    let locations = createDotLocations(numDots,spacing,36,scene);
    gameData.dots = createDots(scene,locations,posY);

    const tween = ABCya.Tweens.addTween(gameData.dots,400,{y:{start:-105,to:posY}})

    ABCya.Tweens.addTween(gameData.uiBar,400,{y:{start:-100,to:28}})
    rollIn(gameData.uiMenu,800,0,Phaser.Math.Easing.Quadratic.InOut);
    rollIn(gameData.uiMute,800,0,Phaser.Math.Easing.Quadratic.InOut,true);

    gameData.uiMenu.setInteractive();
    gameData.uiMute.setInteractive();

    customConvertToButton(gameData.uiMenu);
    customConvertToButton(gameData.uiMute);

    gameData.uiMenu.on('pointerdown',()=>{
        pause(scene);
    });

    gameData.uiMute.on('pointerdown',()=>{
        if(gameData.uiMute.frame.name === "General UI/Btn_Mute")
        {
            gameData.uiMute.setFrame("General UI/Btn_Unmute");
            scene.custSound.unmuteAllTracks();
            //scene.custSound.tracks.bgMusic.resumeAll();
        }
        else
        {
            gameData.uiMute.setFrame("General UI/Btn_Mute");
            scene.custSound.muteAllTracksExcept("vo");
        }
    });

    tween.on('start',()=>{
        for(let each in gameData.dots)
        {
            gameData.dots[each].setAlpha(1);
        }
        gameData.uiBar.setAlpha(1);
    })

    scene.events.on("correct",()=>{
        fillDot(gameData.questionNum);
    });

    //This is the transistion from questions to make a donut
    scene.events.on('complete',()=>{
        //console.log(gameData.dots.length)
        for(let each in gameData.dots)
        {
            const d = gameData.dots[each];
            let time = Math.abs(512 - d.x)*2;

            ABCya.Tweens.addTween([d,d.dot],time,{x:512},Phaser.Math.Easing.Quadratic.InOut,()=>{
                if(Number(each) === gameData.dots.length-1)
                {
                    const tempDot = ABCya.Images.addImage(512,posY,"General UI/Progress_Full",scene).setDepth(4);

                    for(let each in gameData.dots)
                    {
                        gameData.dots[each].dot.destroy();
                        gameData.dots[each].destroy();
                    }

                    locations = createDotLocations(5,25,36,scene);
                    gameData.dots = createDots(scene,locations,posY);

                    ABCya.Tweens.addTween(tempDot,200,{scale:0},Phaser.Math.Easing.Linear,()=>{
                        tempDot.destroy();
                        for(let each in gameData.dots)
                        {
                            ABCya.Tweens.addTween(gameData.dots[each],400,{x:{start:512, to:gameData.dots[each].x},onStart:()=>{
                                gameData.dots[each].setAlpha(1);
                            }})
                        }
                    })
                }
            });
        }
    });
}

export function fillDot(index)
{
    const fill = gameData.dots[index].dot;
    
    ABCya.Tweens.addTween(fill, 500,{scale:1},Phaser.Math.Easing.Quadratic.InOut,()=>{
    });
}

export function unFillDot(index)
{
    const fill = gameData.dots[index].dot;
    ABCya.Tweens.addTween(fill, 100,{scale:0},Phaser.Math.Easing.Quadratic.InOut,()=>{
    });
}

function createDotLocations(numberOfDots,distance,itemWidth)
{
    const startX = 512;
    let returnArray = [];

    if(numberOfDots%2)
    {
        //so if an arrray is odd, one point is known - the middle one. 
        //then every point will be the same absolute distance as its oppsite
        //[0,1,2,3] - 0 and 3, 1 and 2
        //[0,1,2,3,4,5,6]
        const runNum = (numberOfDots - 1)/2; //Only needs to run once for each pair - this determines number of pairs
        const middleNum = runNum + 1;
        /*this is the center number for calculations
          for example in the array of 5, middle num is 3*/
        const arrayLength = runNum*2;
        returnArray[middleNum-1] = startX;//array posistion of middle number, 3rd posistion is labeled 2 etc

        for(let count = 0; count < runNum; count++)
        {
            const lowPair = count-middleNum+1;
            const highPair = middleNum-count-1;
            returnArray[count] = startX + (lowPair)*distance + (lowPair)*itemWidth;
            returnArray[arrayLength-count] = startX + (highPair)*distance + (highPair)*itemWidth;
        }
    }

    //Evens are handled in pairs
    else
    {
        //[0,1,2,3,4,5]
        //pairs are number divided by two 6, means 3 pairs 0-5
        const runNum = numberOfDots/2;
        //middle point is half distance between dots
        for(let count = 0; count < runNum; count++)
        {
            const lowPair = count-runNum;
            const highPair = numberOfDots-count-1;
            const gapCount = runNum - .5 - count;
            returnArray[count] = startX - (gapCount)*distance - (gapCount)*itemWidth;
            returnArray[highPair] = startX + (gapCount)*distance + (gapCount)*itemWidth;
        }
    }

    //console.log(returnArray)

    return returnArray
}

function createDots(scene,posArray,y)
{
    const returnArray = [];

    for(let c = 0; c < posArray.length; c++)
    {
        returnArray.push(ABCya.Images.addImage(posArray[c],y,"General UI/Progress_Empty",scene).setDepth(6).setAlpha(0));
        returnArray[c].dot = ABCya.Images.addImage(posArray[c],y,"General UI/Progress_Full",scene).setDepth(6).setScale(0);
    }
    

    // for(let c in returnArray)
    // {
        // ABCya.Tweens.addTween(returnArray[c],100,{y:0,yoyo:true,delay:100*c})
    // }

    return returnArray
}

export function customConvertToButton(GameObject)
{
    let ButtonConfig = Phaser.Utils.Objects.DeepCopy(ABCya.Buttons.Configs.buttonConfigDefaults);
    ButtonConfig.disabledTint = 0xFFFFFF;
    ABCya.Buttons.convertToButton(GameObject,ButtonConfig);
    GameObject.on('pointerdown',()=>{GameObject.scene.custSound.playSoundCustom('click-select-donuts');});
}

function rollIn(object,timeTaken,delay,ease = Phaser.Math.Easing.Linear,OffLeft = false)
{
    let Rotation;
    let Distance;

    Distance = 6.283 * object.width/2;
    Rotation = Distance/(object.width/2);
    if (OffLeft != true)
    {
        Distance = Distance * -1;
    }
    else
    {
        Rotation = Rotation * -1;
    }

    const tween = ABCya.Tweens.addTween(object,timeTaken,{rotation: Rotation, x: {start:object.x + Distance, to: object.x},delay:delay},ease);
    tween.on('start',()=>{
        object.setAlpha(1);
    })
}